module.exports = __webpack_public_path__ + "static/media/picture-(226).5a630903.JPG";